import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {ConfigService} from '@cosbeni/auth';
import {FormHelperService} from '../services/form-helper.service';
import {ToasterService} from 'angular2-toaster';
import {TranslocoService} from '@jsverse/transloco';

import {ActivePromotionConfig} from '../config/active-promotion.config';
import {DataService} from '@cosbeni/database';

@Component({
    standalone: false,
    selector: 'app-dashboard',
    styleUrls: ['reset-password.component.css'],
    templateUrl: 'reset-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {
    /** 要求元アプリ。backend は 4 アプリ共有なので、リンクのホストはこの値で決まる (issue #171) */
    static readonly SITE = 'active-promotion';

    account: any = {username: ''};
    form: FormGroup;
    sent: boolean = false;

    constructor(public store: Store<any>, public router: Router, public formHelper: FormHelperService, public formBuilder: FormBuilder, public dataService: DataService, public config: ConfigService, public toasterService: ToasterService, public http: HttpClient, private transloco: TranslocoService) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
        });
    }

    reset(value: any) {
        // サーバはユーザの有無にかかわらず同じ応答を返す (アカウント列挙の防止)。
        // 画面も成否で文言を変えない
        this.http.post(ActivePromotionConfig.SERVER_URL + '/rest/public/promotion/password/request', {
            site: ResetPasswordComponent.SITE,
            login: value.username
        }).subscribe(() => {
                this.done();
            },
            () => {
                this.done();
            },
        );
    }

    private done() {
        this.sent = true;
        this.toasterService.pop('info', this.transloco.translate('shell.accepted'), this.transloco.translate('shell.reset_sent'));
    }

}
